<template>
  <div class="page">
    <div class="d-flex flex-column">
      <div class="input-group without-separator">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <font-awesome-icon icon="search" style="color:gray" />
          </span>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Поиск по названию и IMEI"
          aria-label="Поиск по названию и IMEI"
          :value="searchText"
          @input="searchDevice"
        >
      </div>
    </div>
    <router-link to="/devices/create" class="btn btn-primary w-100">Добавить</router-link>
    <table class="table table-hover w-100 mt-3 d-none d-md-table">
      <TableSort class="sticky-2" :sorts="sorts" @sortsUpdate="loadWithSort" />
      <tbody>
        <tr
          v-for="device of devices"
          :key="device.id"
          role="button"
          tabindex="0"
          @click="$router.push(`/devices/${device.id}`)"
        >
          <td>
            <TextHighlight class="highlighter" :queries="searchText">
              {{ device.name }}
            </TextHighlight>
          </td>
          <td>
            <TextHighlight class="highlighter" :queries="searchText">
              {{ device.imei }}
            </TextHighlight>
          </td>
          <td>{{ device.firmware ? device.firmware.name : "" }}</td>
        </tr>
      </tbody>
    </table>
    <div v-for="device of devices" :key="device.id" class="mobile-table-view card mt-2 mb-2 p-2 d-md-none">
      <table v-if="devices.length > 0" class="table borderless">
        <tbody>
          <tr>
            <td style="border-top: none">Название</td>
            <td style="border-top: none">
              <TextHighlight class="highlighter" :queries="searchText">
                {{ device.name }}
              </TextHighlight>
            </td>
          </tr>
          <tr>
            <td>IMEI</td>
            <td>
              <TextHighlight class="highlighter" :queries="searchText">
                {{ device.imei }}
              </TextHighlight>
            </td>
          </tr>
          <tr>
            <td>Прошивка</td>
            <td>{{ device.firmware ? device.firmware.name : "" }}</td>
          </tr>
        </tbody>
      </table>
      <router-link
        :to="{ name: 'devicePage', params: { id: device.id } }"
        class="btn btn-primary btn-md create-device ml-auto"
      >
        Подробно
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TrackDevices',
  props: {
    page: {
      type: String,
      default: () => '1'
    }
  },
  data () {
    return {
      sorts: [
        {
          name: 'Название',
          storeName: 'nameIndex',
          values: ['', 'name', '-name'],
          order: 0
        }, {
          name: 'IMEI',
          storeName: 'imeiIndex',
          values: ['', 'imei', '-imei'],
          order: 1
        }, {
          name: 'Прошивка',
          storeName: 'firmare',
          values: ['', 'firmare', '-firmare'],
          order: 2,
          disabled: true
        }
      ]
    }
  },
  computed: {
    ...mapState('taxi/trackDevice', {
      devices: state => state.items,
      searchText: state => state.searchText,
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading
    })
  },
  watch: {
    page () {
      this.loadItems()
    }
  },
  mounted () {
    this.loadItems()
    this.setTitle([
      {
        title: 'Наблюдение',
        url: '/watch'
      },
      {
        title: 'Устройства'
      }
    ])
  },
  beforeDestroy () {
    this.abortLoading()
  },
  methods: {
    ...mapActions('taxi/trackDevice', [
      'loadItems',
      'abortLoading',
      'setSearch',
      'setSearchText',
      'setSorts'
    ]),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    searchDevice (e) {
      this.setSearchText(e.target.value)
      this.setSearch({ key: 'name', value: e.target.value })
      this.setSearch({ key: 'imei', value: e.target.value })
      this.loadItems()
    },
    loadWithSort (sorts) {
      this.setSorts(sorts)
      this.loadItems()
    }
  }
}
</script>
